import { render, staticRenderFns } from "./CardListRecipe.vue?vue&type=template&id=2d5d938a&scoped=true&"
import script from "./CardListRecipe.vue?vue&type=script&lang=js&"
export * from "./CardListRecipe.vue?vue&type=script&lang=js&"
import style0 from "./CardListRecipe.vue?vue&type=style&index=0&id=2d5d938a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5d938a",
  null
  
)

export default component.exports